module.exports = __webpack_public_path__ + "static/img/icon-tread.22fe7a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-tread.png
// module id = 704
// module chunks = 1